<ng-template #pinnedFiltersTmpl>
  <rt-views-filter-multiselect
    [backAlwaysVisible]="true"
    [selectedFilters]="filterDefs"
    placeholder="app.views.view_settings.pinned_filters"
    (backClick)="onBackClick()"
    (filterChange)="onFilterChange($event)"
    (filterRemove)="onFilterRemove($event)"
    (filterAdd)="onFilterAdd($event)"
  />
</ng-template>

<rt-dropdown-item
  [targetFor]="pinnedFiltersTmpl"
  (click)="viewsAnalytics.settingsPinnedFiltersOpen()"
>
  <rt-icon prefix name="pin" />
  <div layout-vertical>
    <div layout layout-space-between>
      <div layout layout-align-items-center>
        {{ 'app.views.view_settings.pinned_filters' | translate }}
      </div>
      <rt-icon name="chevron-right" />
    </div>
    <span text-small text-weight-default text-color class="description">
      {{
        'app.views.view_settings.pinned_filters_count' | translate: { count: pinnedFiltersCount }
      }}
    </span>
  </div>
</rt-dropdown-item>
